<template>
    <div style="margin: 10px;">
        <div class="horizontal" style="align-items: center;">
            <label style="margin: 0 10px;">{{ $t('SelectAlarmToDisable') }}</label>
            <select style="width: 250px; padding: 10px; margin: 10px; margin-left: 0;" v-model="selectedAlarmType">
                <option v-for="aT in alarmTypes" :key="aT.id" :value="aT">{{ $t( aT.description ) }}</option>
            </select>
            <div @click="add" class="add-icon">
                <img src="@/assets/img/Systems/Add.svg"/>
            </div>
        </div>
        <div style="border-top: 1px solid lightgray; margin: 10px 0;"/>
        <div v-if="rules.length != 0">
            <div>{{ $t('NewRules') }}</div>
            <div v-for="r in rules" :key="r.id" class="rule-container">
                <span>{{ r.description }}</span>
                <div @click="remove(r)" class="add-icon">
                    <img src="@/assets/img/Systems/Remove.svg"/>
                </div>
            </div>
        </div>
        <div class="horizontal" style="justify-content: center;">
            <Button :title="'Save'" buttonClass='save-button semi-bold' style="width: 300px;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>
import Button from '../Button.vue'
import { getNotDisabledAlarmTypesForSystem, addAlarmSystemRules } from '../../api/api'

export default {
    props: {
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        Button
    },
    data() {
        return {
            alarmTypes: [],
            rules: [],
            selectedAlarmType: null
        }
    },
    methods: {
        getData() {
            getNotDisabledAlarmTypesForSystem(this.systemId).then(response => {
                this.alarmTypes = response

                if (this.alarmTypes.length > 0) {
                    this.selectedAlarmType = this.alarmTypes[0]
                }
            })
        },
        save() {
            var systemRules = {
                Rules: this.rules.map(x => { return { SystemId: this.systemId, AlarmTypeId: x.id } })
            }

            addAlarmSystemRules(systemRules).then((_) => this.$emit('save')).catch((error) => {
                if (error.response.data != undefined) {
                    this.error = error.response.data
                } else {
                    this.error = ""
                }
            })
        },
        add() {
            this.rules.push(this.selectedAlarmType)

            var idx = this.alarmTypes.indexOf(this.selectedAlarmType)
            this.alarmTypes.splice(idx, 1)

            this.selectedAlarmType = this.alarmTypes[0]
        },
        remove(rule) {
            var idx = this.rules.indexOf(rule)
            this.rules.splice(idx, 1)

            this.alarmTypes = this.alarmTypes.push(rule).sort((a, b) => a.name - b.name)
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.add-icon {
    cursor: pointer;
}

.rule-container {
    border: 1px solid lightgray;
    margin: 5px 0;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/AddAlarmSystemRuleModal.vue